import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Consultar pesquisas',
      'SUBTITULO': 'Consulte as informações das pesquisas geradas na plataforma em um período específico',
      'CAMPOS': {
        'anio': 'Ano',
        'broker': 'Corretor',
        'brokerCountry': 'País do corretor',
        'anioRanking': 'Classificação por ano',
      },
      'RESULTADOS': {
        'CARGANDO': 'Carregando resultados da pesquisa',
        'TITULO': 'Resultados',
        'ENCONTRADAS': 'Total de pesquisas encontradas',
        'DESCARGAR': 'Baixar informações em formato Excel',
        'SINRESULTADOS': 'Nenhuma pesquisa criada com os parâmetros especificados foi encontrada'
      }
    }
  }
};
